import React from 'react';
import { useLocale } from '../../localization/LocaleContext';
import './CreditExplainer.css';

export default function CreditExplainer() {
    const { t } = useLocale();

    return (
        <section className="sp-90">
            <div className="container">
                <div className="credit-explainer">
                    <h2 className="h-2 h-bold credit-explainer-heading">
                        {t('credits.heading')}
                    </h2>
                    <p className="credit-explainer-subheading">
                        {t('credits.subheading')}
                    </p>

                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="credit-highlight-card">
                                <div className="credit-highlight-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="10"/>
                                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                                        <line x1="12" y1="17" x2="12.01" y2="17"/>
                                    </svg>
                                </div>
                                <h3 className="credit-highlight-title">
                                    {t('credits.oneCredit')}
                                </h3>
                                <p className="credit-highlight-desc">
                                    {t('credits.oneCreditDescription')}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="credit-example">
                                {t('credits.example')}
                            </div>
                        </div>
                    </div>

                    <div className="credit-comparison">
                        <h4>{t('credits.comparisonTitle')}</h4>
                        <div className="credit-plan-badges">
                            <div className="credit-plan-badge">
                                <p className="credit-plan-badge-name">{t('pricing.plans.free.name')}</p>
                                <p className="credit-plan-badge-value">{t('credits.free')}</p>
                            </div>
                            <div className="credit-plan-badge">
                                <p className="credit-plan-badge-name">{t('pricing.plans.premium.name')}</p>
                                <p className="credit-plan-badge-value">{t('credits.premium')}</p>
                            </div>
                            <div className="credit-plan-badge">
                                <p className="credit-plan-badge-name">{t('pricing.plans.ultimate.name')}</p>
                                <p className="credit-plan-badge-value">{t('credits.ultimate')}</p>
                            </div>
                        </div>
                        <p className="credit-renewal-note">{t('credits.renewalNote')}</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
